var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 60,
    viewBox: "0 0 74 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0002 0H7.00016C3.3335 0 0.333496 3 0.333496 6.66667V53.3333C0.333496 57 3.3335 60 7.00016 60H67.0002C70.6668 60 73.6668 57 73.6668 53.3333V6.66667C73.6668 3 70.6668 0 67.0002 0ZM67.0002 50C67.0002 51.8333 65.5002 53.3333 63.6668 53.3333H10.3335C8.50016 53.3333 7.00016 51.8333 7.00016 50V10C7.00016 8.16667 8.50016 6.66667 10.3335 6.66667H63.6668C65.5002 6.66667 67.0002 8.16667 67.0002 10V50ZM47.9668 19C46.6668 17.7 44.5668 17.7 43.2668 19L37.0002 25.3L30.7002 19C29.4002 17.7 27.3002 17.7 26.0002 19C24.7002 20.3 24.7002 22.4 26.0002 23.7L32.3002 30L26.0002 36.3C24.7002 37.6 24.7002 39.7 26.0002 41C27.3002 42.3 29.4002 42.3 30.7002 41L37.0002 34.7L43.3002 41C44.6002 42.3 46.7002 42.3 48.0002 41C49.3002 39.7 49.3002 37.6 48.0002 36.3L41.7002 30L48.0002 23.7C49.2668 22.4333 49.2668 20.3 47.9668 19Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.3e03a67a371ccf08fbee2ff716917ada.svg";
export { ForwardRef as ReactComponent };